import { render } from "./tutorial.vue?vue&type=template&id=1d1e9c6c&scoped=true"
import script from "./tutorial.vue?vue&type=script&lang=js"
export * from "./tutorial.vue?vue&type=script&lang=js"

import "./tutorial.vue?vue&type=style&index=0&id=1d1e9c6c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1e9c6c"]])

export default __exports__